// extracted by mini-css-extract-plugin
export default {"wrapper":"QuizChangeWords_wrapper__dhWMp"};